export default __webpack_public_path__ + "static/media/bg_login.09d82c05.webp";